import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './TabsHorizontal.css';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { getColorByTheme, getPageThemeColors, get, canUseDOM, hexToRgb } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { isNil } from '../../utils/IsNil';
import { qsToObject } from '../../utils/querystring';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
import { ReactComponent as IconBoldChevronRight } from '../../resources/icons/IconBoldChevronRight.svg';
import { checkJssError } from '../../utils/checkJssError';
var classItemWidthMap = {
  1: "oneItem",
  2: "twoItem",
  3: "threeItem",
  4: "fourItem"
};
var isMobile = function isMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
};
var getTopPosition = function getTopPosition() {
  return window.matchMedia('(min-width: 993px)').matches ? '35' : window.matchMedia('(min-width: 768px) and (max-width: 992px)').matches ? '51' : isMobile() ? '51' : 'auto';
};
var getTagsValue = function getTagsValue(location) {
  return canUseDOM ? qsToObject(location.search)['tags'] || '' : '';
};
var TabsHorizontalComponent = function TabsHorizontalComponent(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var tabsHorizontalContainerRef = useRef(null);
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var location = useLocation();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    currentSectionAnchor = _useState4[0],
    setCurrentSectionAnchor = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    leftButtonVisibility = _useState6[0],
    setLeftButtonVisibility = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    rightButtonVisibility = _useState8[0],
    setRightButtonVisibility = _useState8[1];
  var _useState9 = useState(function () {
      return getTagsValue(location);
    }),
    _useState10 = _slicedToArray(_useState9, 1),
    tagsValue = _useState10[0];
  var links = get(fields, 'data.datasource.items', []);
  var isStickyMode = get(params, 'isSticky', false);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }

  /* Params elements */
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  var variables = BackgroundColorHex ? {
    '--tabs-horizontal-background-color': BackgroundColorHex,
    '--tabs-horizontal-background-color-rgb': hexToRgb(BackgroundColorHex, true),
    '--tabs-horizontal-background-active-color': ActiveColorHex,
    '--tabs-horizontal-color': ColorHex
  } : {
    '--tabs-horizontal-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--tabs-horizontal-background-color-rgb': hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    '--tabs-horizontal-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--tabs-horizontal-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  var anchorHandler = function anchorHandler(anchor) {
    if (isNil(anchor) || anchor.trim() === '') {
      return;
    }
    var anchorElement = document.querySelector("[data-anhor=".concat(anchor, "]"));
    anchorElement && anchorElement.scrollIntoView({
      behavior: 'smooth'
    });
  };
  var anchorAddScrollStyles = function anchorAddScrollStyles() {
    var tabs = document.getElementsByClassName('tabs-wrapper')[0].getBoundingClientRect();
    var tabsHeight = tabs.height;
    var tabsYPosition = tabs.top + window.scrollY;
    document.querySelectorAll('[data-anhor]').forEach(function (anchorElement) {
      var anchorYPosition = anchorElement.getBoundingClientRect().top + window.scrollY;
      if (anchorYPosition <= tabsYPosition) {
        var offset = window.matchMedia('(max-width: 992px)').matches ? 72 : 55;
        anchorElement.style.scrollMarginTop = "".concat(tabsHeight + offset, "px");
        return;
      }
      anchorElement.style.scrollMarginTop = "".concat(tabsHeight, "px");
    });
  };
  var tabPositionChanger = function tabPositionChanger() {
    var prevScrollPos = window.pageYOffset;
    return function () {
      var tabs = document.querySelector('.stickyTabContainer');
      if (isNil(tabs)) {
        return;
      }
      var currentTopPosition = getTopPosition();
      var currentScrollPos = window.pageYOffset;
      if (prevScrollPos > currentScrollPos) {
        // Scrolling up, show header
        tabs.style.top = "".concat(currentTopPosition, "px");
      } else {
        // Scrolling down, hide header
        tabs.style.top = '-21px';
      }
      prevScrollPos = currentScrollPos;
    };
  };
  var addStickyStyles = function addStickyStyles() {
    var tabs = document.querySelector('.stickyTabContainer');
    if (isNil(tabs)) {
      return;
    }
    tabs.style.top = '-21px';
    tabs.style.position = 'sticky';
    tabs.style.transition = 'all .4s linear';
    tabs.style.zIndex = '8';
  };
  var handleActiveTab = function handleActiveTab() {
    var tabs = document.querySelector('.stickyTabContainer');
    return function () {
      var tabsRect = tabs.getBoundingClientRect();
      var anhorSections = document.querySelectorAll('[data-anhor]');
      Array.from(anhorSections).some(function (anhorSection) {
        var anhorSectionRect = anhorSection.getBoundingClientRect();
        var tabsYBottomPosition = tabsRect.bottom + window.scrollY;
        var anchorYTopPosition = anhorSectionRect.top + window.scrollY;
        var anchorYBottomPosition = anhorSectionRect.bottom + window.scrollY;
        if (anchorYTopPosition <= tabsYBottomPosition && tabsYBottomPosition < anchorYBottomPosition) {
          var anhor = anhorSection.getAttribute('data-anhor');
          setCurrentSectionAnchor(anhor);
          return true;
        } else {
          setCurrentSectionAnchor('');
        }
      });
    };
  };
  var observeTabsPosition = function observeTabsPosition() {
    var tabs = document.querySelector('.stickyTabContainer');
    var tabsTop = tabs.getBoundingClientRect().top;
    var currentTopPosition = getTopPosition();
    if (isMobile() || isMobile() && tabs.classList.contains('stickyTabContainerBefore')) {
      tabs.classList.remove('stickyTabContainerBefore');
      return;
    }
    tabs.classList.toggle('stickyTabContainerBefore', tabsTop <= parseInt(currentTopPosition));
  };
  useEffect(function () {
    if (isStickyMode) {
      addStickyStyles();
      anchorAddScrollStyles();
      handleActiveTab()();
      observeTabsPosition();
      window.addEventListener('resize', checkForDisabledButtons);
      window.addEventListener('touchend', checkForDisabledButtons);
      window.addEventListener('scroll', handleActiveTab());
      window.addEventListener('scroll', anchorAddScrollStyles);
      window.addEventListener('scroll', tabPositionChanger());
      window.addEventListener('scroll', observeTabsPosition);
    }
    checkForDisabledButtons();
    return function () {
      if (isStickyMode) {
        window.removeEventListener('resize', checkForDisabledButtons);
        window.removeEventListener('touchend', checkForDisabledButtons);
        window.removeEventListener('scroll', anchorAddScrollStyles);
        window.removeEventListener('scroll', handleActiveTab());
        window.removeEventListener('scroll', tabPositionChanger());
        window.removeEventListener('scroll', observeTabsPosition);
      }
    };
  }, []);
  useEffect(function () {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  useEffect(function () {
    setTimeout(checkForDisabledButtons, 200);
  }, [sitecoreContext.selectedFontSize]);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.datasource)) {
    console.info('TabsHorizontal component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TabsHorizontal component is empty: please provide data source]");
    }
    return null;
  }
  var getAvgScrollWidth = function getAvgScrollWidth(childNodes) {
    var acc = 0;
    childNodes.forEach(function (el, index) {
      if (childNodes.length - 1 === index) {
        acc = acc / index;
        return acc;
      }
      acc += el.offsetWidth;
      return acc;
    }, 0);
    return Math.round(acc) + 15;
  };
  var checkForDisabledButtons = function checkForDisabledButtons() {
    setTimeout(function () {
      var _tabsHorizontalContai = tabsHorizontalContainerRef.current,
        scrollLeft = _tabsHorizontalContai.scrollLeft,
        clientWidth = _tabsHorizontalContai.clientWidth,
        scrollWidth = _tabsHorizontalContai.scrollWidth;
      if (rtl) {
        if (scrollLeft === 0) {
          setLeftButtonVisibility(false); // the start of nav list, hide right button
        } else if (scrollLeft !== 0) {
          setLeftButtonVisibility(true);
        }
        if (parseInt((scrollWidth + parseInt(scrollLeft.toString())).toString()) === clientWidth || parseInt((scrollWidth + parseInt(scrollLeft.toString())).toString()) + 1 === clientWidth || parseInt((scrollWidth + parseInt(scrollLeft.toString())).toString()) - 1 === clientWidth) {
          setRightButtonVisibility(false); // the end of nav list, hide left button
          return;
        } else {
          return setRightButtonVisibility(true);
        }
      }
      if (scrollLeft === 0) {
        setRightButtonVisibility(false); // the start of nav list, hide left button
      } else if (scrollLeft !== 0) {
        setRightButtonVisibility(true);
      }
      if (parseInt((scrollWidth - parseInt(scrollLeft.toString())).toString()) === clientWidth || parseInt((scrollWidth - parseInt(scrollLeft.toString())).toString()) + 1 === clientWidth || parseInt((scrollWidth - parseInt(scrollLeft.toString())).toString()) - 1 === clientWidth) {
        setLeftButtonVisibility(false); // the end of nav list, hide right button
        return;
      } else {
        return setLeftButtonVisibility(true);
      }
    }, 200);
  };
  var scroll = function scroll(scrollOffsetType) {
    var _tabsHorizontalContai2 = tabsHorizontalContainerRef.current,
      scrollLeft = _tabsHorizontalContai2.scrollLeft,
      childNodes = _tabsHorizontalContai2.childNodes;
    var averageScrollValue = getAvgScrollWidth(childNodes);
    if (scrollOffsetType === 'left') {
      tabsHorizontalContainerRef.current.scrollTo({
        left: !rtl ? scrollLeft - averageScrollValue : scrollLeft + averageScrollValue,
        behavior: 'smooth'
      });
    }
    if (scrollOffsetType === 'right') {
      tabsHorizontalContainerRef.current.scrollTo({
        left: !rtl ? scrollLeft + averageScrollValue : scrollLeft - averageScrollValue,
        behavior: 'smooth'
      });
    }
    checkForDisabledButtons();
  };
  var clickTabsHorizontalAnalytics = function clickTabsHorizontalAnalytics(title) {
    tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['clickTabsHorizontalAnalytics'], _objectSpread(_objectSpread(_objectSpread({}, params), eventsAnalytics['clickTabsHorizontalAnalytics'].eventAct && {
      eventAct: eventsAnalytics['clickTabsHorizontalAnalytics'].eventAct
    }), eventsAnalytics['clickTabsHorizontalAnalytics'].eventCat !== 'Modules' && {
      eventCat: eventsAnalytics['clickTabsHorizontalAnalytics'].eventCat
    })), title);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('tabs-container', {
      'tabs-container--right-scroll': rightButtonVisibility,
      'tabs-container--left-scroll': leftButtonVisibility
    })
  }, /*#__PURE__*/React.createElement("nav", {
    className: "tabs-wrapper",
    ref: tabsHorizontalContainerRef
  }, links.map(function (item, index) {
    var link = item.link.jss.value;
    var linkLabelValue = item.linkLabel.jss.value;
    var isActiveValue = item.isActive.jss.value;
    var generalClassName = "".concat(classItemWidthMap[links.length], " tabs-wrapper__item");
    return isActiveValue || currentSectionAnchor !== '' && currentSectionAnchor === link.anchor || tagsValue !== '' && link.href.includes(tagsValue) ? /*#__PURE__*/React.createElement("span", {
      key: "".concat(index, "-").concat(link.href),
      className: "".concat(generalClassName, " tabs-wrapper__item--active")
    }, linkLabelValue) : /*#__PURE__*/React.createElement(RouterLink, {
      key: "".concat(index, "-").concat(link.href),
      className: generalClassName,
      href: link.href,
      linktype: link.linktype,
      title: "".concat(linkLabelValue, " | ").concat(link.title),
      onClick: function onClick() {
        clickTabsHorizontalAnalytics(linkLabelValue);
        return anchorHandler(link.anchor);
      },
      openInSameTab: true
    }, linkLabelValue);
  })), rightButtonVisibility && links.length >= 5 ? /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['operatingOptionsAnalytics'], _objectSpread(_objectSpread(_objectSpread({}, params), eventsAnalytics['operatingOptionsAnalytics'].eventAct && {
        eventAct: eventsAnalytics['operatingOptionsAnalytics'].eventAct
      }), eventsAnalytics['operatingOptionsAnalytics'].eventCat !== 'Modules' && {
        eventCat: eventsAnalytics['operatingOptionsAnalytics'].eventCat
      })), 'previous');
      scroll(!rtl ? 'left' : 'right');
    },
    className: "tabsScrollButtonLeft"
  }, /*#__PURE__*/React.createElement(IconBoldChevronRight, {
    className: "icon leftIcon"
  })) : null, leftButtonVisibility && links.length >= 5 ? /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['operatingOptionsAnalytics'], _objectSpread(_objectSpread(_objectSpread({}, params), eventsAnalytics['operatingOptionsAnalytics'].eventAct && {
        eventAct: eventsAnalytics['operatingOptionsAnalytics'].eventAct
      }), eventsAnalytics['operatingOptionsAnalytics'].eventCat !== 'Modules' && {
        eventCat: eventsAnalytics['operatingOptionsAnalytics'].eventCat
      })), 'next');
      scroll(!rtl ? 'right' : 'left');
    },
    className: "tabsScrollButtonRight"
  }, /*#__PURE__*/React.createElement(IconBoldChevronRight, {
    className: "icon"
  })) : null));
};
var TabsHorizontal = function TabsHorizontal(props) {
  return checkJssError(props, TabsHorizontalComponent, props.fields.data.datasource);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var rtl = _ref2.rtl,
    children = _ref2.children,
    style = _ref2.style,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "stickyTabContainer ".concat(commonStyles, " ").concat(globalStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    style: style,
    removePaddingMobile: true
  }, children);
};
var tabsScrollMixin = "\n   text-align: center;\n   border-radius: 4px;\n   border: none;\n   height: 35px;\n   width: 35px;\n   background: var(--tabs-horizontal-background-color);\n   position: absolute;\n   top: calc(50% - 17px);\n   padding: 0;\n   z-index: 1;\n";
var globalStyles = "gmr9eth";
var commonStyles = "cnk22g8";
var ltrStyles = "lkl5stt";
var rtlStyles = "roix15n";
export default TabsHorizontal;